// src/data/services.tsx
import { JSX } from 'react';
import { Globe, Smartphone, LineChart, Brain, Cog } from 'lucide-react';
import { SiWhatsapp } from '@icons-pack/react-simple-icons';

export interface ServiceCard {
  id: string;
  title: string;
  icon: JSX.Element;
  items: string[];
  description: string;
}

export const services: ServiceCard[] = [
  {
    id: 'web',
    title: 'Web',
    icon: <Globe className="h-10 w-10" />,
    items: [
      'Responsive Web Design & Dev',
      'Strategic UI/UX Solutions',
      'Brand-aligned Corporate Sites',
      'WordPress Optimization',
      'High-conversion E-commerce',
    ],
    description:
      'We create stunning, responsive websites that deliver exceptional user experiences across all devices. Our web solutions are built with performance, accessibility, and scalability in mind.',
  },
  {
    id: 'app',
    title: 'Apps',
    icon: <Smartphone className="h-10 w-10" />,
    items: [
      'Cross-platform Mobile Apps',
      'Tailored CRM Systems',
      'Secure Intranet Solutions',
      'Seamless API Connectivity',
      'Developer Efficiency Tools',
    ],
    description:
      'From native mobile applications to progressive web apps, we craft intuitive digital experiences that engage users and drive business outcomes. Our app development process focuses on performance and usability.',
  },

  {
    id: 'ai',
    title: 'AI',
    icon: <Brain className="h-10 w-10" />,
    items: [
      'Custom ML Solutions',
      'AI Integration',
      'Natural Language Processing',
      'Computer Vision Systems',
      'Predictive Analytics',
    ],
    description:
      'Harness the power of artificial intelligence to automate processes, gain insights, and create innovative solutions. Our AI implementations are practical, ethical, and designed to deliver measurable ROI.',
  },
  {
    id: 'whatsapp-business-solutions',
    title: 'WhatsApp Business Solutions',
    // SiWhatsapp defaults to currentColor, matching how other icons inherit
    // the active/inactive text color set by the parent tab/card styling.
    icon: <SiWhatsapp size={40} />,
    items: [
      'Meta Cloud API Integration',
      'CRM & Helpdesk Connectivity',
      'Automated Notifications & Alerts',
      'Smart Conversation Routing',
      'WhatsApp Business App Coexistence',
    ],
    description:
      "We help businesses connect their WhatsApp number to the tools they already use. Using Meta's WhatsApp Business Platform (Cloud API), we build integrations that let our clients receive and respond to customer messages inside their CRM or helpdesk, send automated order and appointment updates, and route conversations to the right team automatically.",
  },
  {
    id: 'analytics',
    title: 'Analytics',
    icon: <LineChart className="h-10 w-10" />,
    items: [
      'Web & Server-side GTM',
      'GA4 & Firebase Analytics',
      'BigQuery & Looker Studio Dashboards',
      'Conversion APIs & Tracking',
      'Analytics Consultation',
    ],
    description:
      'Transform your data into actionable insights with our comprehensive analytics solutions. We implement robust tracking systems and build custom dashboards that visualize your key metrics clearly.',
  },
  {
    id: 'automation',
    title: 'Automations',
    icon: <Cog className="h-10 w-10" />,
    items: [
      'Workflow Automation',
      'Business Process Optimization',
      'CI/CD Implementation',
      'DevOps Solutions',
      'Automated Testing',
    ],
    description:
      'Streamline your operations with intelligent automation solutions that reduce manual effort and increase accuracy. We design custom automation workflows that integrate seamlessly with your existing systems.',
  },
];
